import PropTypes from "prop-types";
import { Avatar, Box, Stack, Typography } from "@mui/material";

const RestaurantHeader = ({ restaurant }) => (
  <Stack alignItems="center" spacing={1} sx={{ mb: 3, textAlign: "center" }}>
    {restaurant && restaurant.logo ? (
      <Box
        component="img"
        src={restaurant.logo}
        alt={`${restaurant.name} logo`}
        sx={{ maxWidth: 160, maxHeight: 96, objectFit: "contain" }}
      />
    ) : (
      <Avatar sx={{ width: 64, height: 64, bgcolor: "primary.main", fontSize: 28 }}>
        {restaurant && restaurant.name ? restaurant.name.charAt(0).toUpperCase() : ""}
      </Avatar>
    )}
    <Typography variant="h4" component="h1">
      {restaurant ? restaurant.name : ""}
    </Typography>
    {restaurant && restaurant.altName ? (
      <Typography variant="subtitle1" color="text.secondary">
        {restaurant.altName}
      </Typography>
    ) : null}
  </Stack>
);

RestaurantHeader.propTypes = {
  restaurant: PropTypes.shape({
    name: PropTypes.string,
    altName: PropTypes.string,
    logo: PropTypes.string,
  }),
};

export default RestaurantHeader;
